import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth } from '../config/firebase';
import { 
  signInWithPhoneNumber, 
  RecaptchaVerifier,
  signOut
} from 'firebase/auth';
import { userService } from '../services/api.service';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showUserForm, setShowUserForm] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          // Intentar obtener datos del usuario de MongoDB
          const userData = await userService.getUser(user.uid);
          setUser({ ...user, userData });
          setShowUserForm(false);
        } catch (error) {
          // Si el usuario no existe en MongoDB, mostrar formulario
          setUser(user);
          setShowUserForm(true);
        }
      } else {
        setUser(null);
        setShowUserForm(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const signIn = async (phoneNumber, recaptchaVerifier) => {
    try {
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
      return confirmationResult;
    } catch (error) {
      throw error;
    }
  };

  const submitUserData = async (userData) => {
    try {
      const response = await userService.createUser({
        firebaseId: user.uid,
        ...userData
      });
      setUser({ ...user, userData: response });
      setShowUserForm(false);
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      setUser(null);
      setShowUserForm(false);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      throw error;
    }
  };

  const checkUserData = async () => {
    try {
      if (!user) return false;
      
      const response = await fetch(`/api/users/${user.uid}`);
      if (!response.ok) {
        throw new Error('Error al obtener datos del usuario');
      }
      
      const userData = await response.json();
      return userData && userData.hasCompletedProfile;
    } catch (error) {
      console.error('Error al verificar datos del usuario:', error);
      return false;
    }
  };

  const value = {
    user,
    loading,
    signIn,
    showUserForm,
    submitUserData,
    logout,
    checkUserData,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 